import styled from 'styled-components'
import { white, gray, grayLight, grayDark } from '@bufferapp/ui/style/colors'

import { baseFont } from '~/shared/styles/font'
import { flexRow } from '~/shared/styles/layout'

// NOTE: This will probably be extracted as 'Layout' components.
// Keeping them here for now.
export const SidebarWrapper = styled.aside`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: ${white};
  border-right: 1px solid ${gray};
`

export const SidebarHeader = styled.div`
  ${flexRow}
  justify-content: space-between;
  height: 80px;
  width: 100%;
  padding: 8px;
  border-bottom: 1px solid ${grayLight};

  & > * {
    margin-right: 8px;
  }

  & > :last-child {
    margin-right: 0px;
  }
`

export const SidebarMessage = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-bottom: 1px solid ${grayLight};
  ${baseFont}
  line-height: 20px;
  color: ${grayDark};
`

export const SidebarContent = styled.div`
  width: 452px;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 0px;
`

export const ContentWrapper = styled.div`
  width: 552px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0px;
  margin: 0 auto;
`
